import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OrdersComponent } from "./skitbs/orders/orders.component";
import { HistoryComponent } from "./skitbs/history/history.component";
import { MenuPlansComponent } from "./skitbs/menuplans/menu-plans.component";
import { InvoicesComponent } from "./skitbs/invoices/invoices.component";
import { MessagesComponent } from "./skitbs/messages/messages.component";
import { LoginComponent } from "./skitbs/base/template/login.component";
import { AuthGuard } from "./skitbs/base/auth/auth.guard";
import { ProfileComponent } from "./skitbs/profile/profile.component";
import { OrderDetailsComponent } from "./skitbs/orders/order-details.component";
import { PrepaidComponent } from "./skitbs/prepaid/prepaid.component";
import { ContractTerminationComponent } from './skitbs/contractTermination/contractTermination.component';
import { UserConfirmationComponent } from './skitbs/notifications/userConfirmaton.component';
import { ContactComponent } from './skitbs/base/template/contact.component';
import { ImprintComponent } from './skitbs/base/template/imprint.component';
import { DisclaimerComponent } from './skitbs/base/template/disclaimer.component';


const routes: Routes = [
    { path: '', redirectTo: '/orders', pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'login/:cpnr', component: LoginComponent },
    { path: 'orders', component: OrdersComponent, canActivate: [AuthGuard] },
    { path: 'order-details', component: OrderDetailsComponent, canActivate: [AuthGuard] },
    { path: 'history', component: HistoryComponent, canActivate: [AuthGuard] },
    { path: 'menuplans', component: MenuPlansComponent, canActivate: [AuthGuard] },
    { path: 'invoices', component: InvoicesComponent, canActivate: [AuthGuard] },
    { path: 'messages', component: MessagesComponent, canActivate: [AuthGuard] },
    { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
    { path: 'prepaid', component: PrepaidComponent, canActivate: [AuthGuard] },
    { path: 'reload', component: OrdersComponent, canActivate: [AuthGuard] }, // !! used to reload views !!
    { path: 'user-confirmation', component: UserConfirmationComponent, canActivate: [AuthGuard] },
    { path: 'contract-termination', component: ContractTerminationComponent, canActivate: [AuthGuard] },
    { path: 'contact', component: ContactComponent },
    { path: 'imprint', component: ImprintComponent },
    { path: 'disclaimer', component: DisclaimerComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: false })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}